import angular from 'angular';

// Component
import formComponent from './recapResponseForm.component';
import './recapResponseForm.css';

// Dependencies
import formResponseComponent from '../recapResponseFormResponse';

let module = angular.module('recaps.components.recapResponseForm', [
  formResponseComponent.name,
]);

module.component('recapResponseForm', formComponent);

export default module;
